<template>
  <div>
    <div class="doctors-search-result" v-if="!loading && doctorsList.results && doctorsList.results.length > 0">
      <div class="mb-2" v-for="doctor in doctorsList.results" :key="doctor.id">
        <DirectoryCard :info="doctor" :type="'hospital_administrator'" :fetchDoc="getDoctors" />
      </div>
      <div class="phy-pagination-container" v-if="doctorsList.results.length > 0 && !loading && totalResults > 3">
        <span
          @click="
            $router.push({
              name: 'HospitalSearch',
              params: {
                search: searchName,
                location: location,
                payloadloc: payloadloc,
              },
            })
          "
        >
          <button class="pagination-btn" :style="{ color: getPrimaryColor() }">
            View {{ intToString(totalResults - 3) }} more hospitals
            <font-awesome-icon
              size="2x"
              class="mr-2"
              :style="{
                transform: 'scale(0.7)',
                width: '30px',
                marginTop: '-4px',
                color: getPrimaryColor(),
              }"
              :icon="['fa', 'arrow-right']"
            />
          </button>
        </span>
      </div>
    </div>
    <div v-if="doctorsList.results && doctorsList.results.length === 0 && !loading">
      <div class="no-results-container col-12 mt-3">
        <div class="no-results">
          <div class="search-icon">
            <font-awesome-icon
              :icon="['fal', 'search']"
              :style="{
                color: getPrimaryColor(),
              }"
            />
          </div>
          <h5 class="no-results-found">No Results Found</h5>

          <div class="request">
            <p :style="{ 'margin-bottom': '0px' }">We couldn’t find any results based on your search.</p>
            <p>Please try searching with another term.</p>
            <p>Would you like to add this profile on DoveMed?</p>
          </div>

          <div class="add-clinic-container">
            <p class="add-clinic cp" :style="{ color: getPrimaryColor() }" @click="handleHospitalModal">Add Hospital Profile</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>
    <AddHospitalModal ref="AddHospitalModal" :handleChangeTab="handleChangeTab" />
  </div>
</template>

<script>
import NewProvider from "./NewCard.vue"
import { mapState } from "vuex"
import DirectoryCard from "../provider/DirectoryCard.vue"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import AddHospitalModal from "../../Modals/AddHospitalModal.vue"
import Repository from "../../../repositories/Repository"
const UserRepository = RepositoryFactory.get("user")
const MedicalRepository = RepositoryFactory.get("medicaldirectory")
const AppRepository = RepositoryFactory.get("app")
export default {
  name: "HospitalCard",
  components: {
    NewProvider,
    AddHospitalModal,
    DirectoryCard,
  },
  props: {
    setHospitalCount: Function,
    searchName: String,
    location: Object,
    payloadloc: Object,
  },
  data() {
    return {
      tabs: { search: true, add: false },
      sortKey: "distance",
      nextPage: 0,
      currentPage: 1,
      loading: true,
      totalResults: 0,
      doctorsList: { results: [] },
    }
  },

  mounted() {
    this.getDoctors()
  },

  created() {
    console.warn("HospitalCard.vue is created")
    // this.getDoctors();
  },

  watch: {
    searchName() {
      this.callDebounce()
    },
  },

  methods: {
    callDebounce: _.debounce(function () {
      this.getDoctors()
    }, 500),

    async getDoctors() {
      // console.log("getDoctors() is called")

      this.loading = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        // northEast: {
        //   lat: this.location.lat ? this.location.lat : 57.539416794474995,
        //   lng: this.location.lng ? this.location.lng : -62.05078125000001,
        // },
        // northWest: {
        //   lat: this.location.lat ? this.location.lat : 57.539416794474995,
        //   lng: this.location.lng ? this.location.lng : -128.67187500000003,
        // },
        // southEast: {
        //   lat: this.location.lat ? this.location.lat : 15.029685756555674,
        //   lng: this.location.lng ? this.location.lng : -62.05078125000001,
        // },
        // southWest: {
        //   lat: this.location.lat ? this.location.lat : 15.029685756555674,
        //   lng: this.location.lng ? this.location.lng : -128.67187500000003,
        // },
        // northEast: {
        //   lat: this.location.lat ? this.location.lat : this.payloadloc.lat,
        //   lng: this.location.lng ? this.location.lng : this.payloadloc.lng,
        // },
        // northWest: {
        //   lat: this.location.lat ? this.location.lat : this.payloadloc.lat,
        //   lng: this.location.lng ? this.location.lng : this.payloadloc.lng,
        // },
        // southEast: {
        //   lat: this.location.lat ? this.location.lat : this.payloadloc.lat,
        //   lng: this.location.lng ? this.location.lng : this.payloadloc.lng,
        // },
        // southWest: {
        //   lat: this.location.lat ? this.location.lat : this.payloadloc.lat,
        //   lng: this.location.lng ? this.location.lng : this.payloadloc.lng,
        // },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: {
          item_type: "hospital",
        },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) payload.filters.search_name = this.searchName
      document.body.scrollTop = 0

      MedicalRepository.PostMedicalDirectorySearch(this.currentPage, 3, this.currentCircle.id, this.sortKey, payload, this.payloadloc)
        .then(res => {
          if (res.data.results) {
            this.doctorsList.results = res.data.results
          } else {
            this.doctorsList.results = []
          }
          this.totalResults = res.data.totalResults
          this.setHospitalCount(this.totalResults)
          this.loading = false
        })
        .catch(() => (this.loading = false))
    },
    handleHospitalModal() {
      this.$refs.AddHospitalModal.showModal(this.currentCircle.id)
    },

    handleChangeTab() {
      this.tabs.search = true
      this.tabs.add = false
      this.updateColor("search")
      this.getDoctors()
    },
    intToString(num) {
      num = num.toString().replace(/[^0-9.]/g, "")
      if (num < 1000) {
        return num
      }
      let si = [
        { v: 1e3, s: "K" },
        { v: 1e6, s: "M" },
        { v: 1e9, s: "B" },
        { v: 1e12, s: "T" },
        { v: 1e15, s: "P" },
        { v: 1e18, s: "E" },
      ]
      let index
      for (index = si.length - 1; index > 0; index--) {
        if (num >= si[index].v) {
          break
        }
      }
      return (num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[index].s
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: "769px") {
  .pagination-btn {
    width: 100% !important;
  }
}
.phy-pagination-container {
  .pagination-btn {
    padding: 8px;
    gap: 4px;
    width: 790px;
    height: 46px;
    background: #f1f5f9;
    border-radius: 8px;
    border: none;
    align-items: center;
    display: flex;
    justify-content: center;
  }
}
.no-results-container {
  background: #f1f5f9;
  border-radius: 8px;
  padding: 24px;

  .no-results {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 8px;

    .search-icon {
      background: #ffffff;
      border: 1px solid #f8fafd;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .no-results-found {
      font-family: "Lato";
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;

      text-align: center;

      color: #0f1734;
    }
    .request {
      p {
        font-family: "Lato";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;

        text-align: center;
        color: #33415f;
      }
    }

    .add-clinic {
      font-family: "Lato";
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
    }
    .add-clinic-container {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 10px;
      gap: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/MedicalDirectories/HospitalCard.vue